export type Loading = 'idle' | 'pending' | 'succeeded' | 'failed';

export enum LOADING {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
